import React, { useEffect } from "react";
import {
  Container,
  Form,
  Section,
  ImageFila,
  ImageCartDark,
  LineContainer,
} from "./styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ISale } from "../../classes/interfaces";
import { getSaleDetail } from "../../services/orderService";
import { buildWhatsAppShareUrl } from "../../helpers/whatsappShare.helper";
import { auth } from "../../classes/auth";
import ConfirmSendModal from "./components/ConfirmSendModal";
import WaitingConfirmationCard from "./components/WaitingConfirmationCard";

export default function SaleTerminatePage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { saleId } = useParams<{ saleId: string }>();
  const [state, setState] = React.useState({ status: "create", token: "" });
  const [sale, setSale] = React.useState<ISale>();

  const [modalIsOpen, setIsOpen] = React.useState(false);
  function closeModal() {
    setIsOpen(false);
  }

  const getSale = (forcarCarregar: boolean = false) => {
    if (!sale || sale.products.length <= 0 || forcarCarregar) {
      // getSaleDetail() throws on a missing/non-200 res.data.code, so setSale is now
      // only ever reached via .then() -- this also fixes the same pre-existing
      // fall-through bug already fixed in Order/index.tsx, where the original inline
      // code fell through to setSale(res.data.data) unconditionally even when
      // res.data.code !== 200, because it was missing a `return` after that branch.
      getSaleDetail(saleId)
        .then(setSale)
        .catch(() => {
          setState({ status: "404", token: state.token });
        });
    }
  };

  const getAuthorization = () => {
    if (state.token === "") {
      auth().then((token) => {
        if (token !== undefined && token !== "") {
          state.status = "allowed";
          state.token = token;
          setState({ status: "allowed", token: token });
          getSale();
        }
      });
    } else {
      getSale();
    }
  };

  useEffect(() => {
    getAuthorization();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getAuthorization is redefined every render (closes over state/sale); adding it here would re-run this effect on every render instead of once on mount
  }, []);

  useEffect(() => {
    if (sale?.store.cellPhone) sendSalesToWhatsApp()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sendSalesToWhatsApp is redefined every render; adding it would risk re-firing the WhatsApp send effect at the wrong time
  }, [sale])

  if (
    sale === undefined ||
    sale.products === undefined ||
    sale.products.length <= 0
  ) {
    return (
      <Container>
        <Form
          onSubmit={(ev) => {
            ev.preventDefault();
          }}
        >
          <LineContainer>
            <LineContainer>
              <Section>
                <ImageCartDark />
                Carregando Meu Pedido...
              </Section>
            </LineContainer>
          </LineContainer>
        </Form>
      </Container>
    );
  }

  const sendSalesToWhatsApp = () => {
    const win = window.open(buildWhatsAppShareUrl(sale, pathname), "_blank");
    if (win) {
      win.focus();
    }

    navigate(`/order/${saleId}`);
  };

  return (
    <Container>

      <ConfirmSendModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        onConfirm={sendSalesToWhatsApp}
      />

      <Form
        onSubmit={(ev) => {
          ev.preventDefault();
        }}
      >
        <Section>
          <ImageFila />
          Aguardando confirmação
        </Section>

        <WaitingConfirmationCard onTrackOrder={() => navigate(`/order/${saleId}`)} />
      </Form>
    </Container>
  );
}
